export const SearchIcon = ({
  height = "20",
  width = "20",
}: {
  height?: string;
  width?: string;
}) => (
    <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.125 17.2413L13.405 12.5213C14.5393 11.1596 15.1049 9.41303 14.9842 7.64495C14.8635 5.87687 14.0658 4.22338 12.757 3.02846C11.4483 1.83354 9.72922 1.18918 7.95748 1.22944C6.18574 1.2697 4.49773 1.99147 3.2446 3.2446C1.99147 4.49773 1.2697 6.18574 1.22944 7.95748C1.18918 9.72922 1.83354 11.4483 3.02846 12.757C4.22338 14.0658 5.87687 14.8635 7.64495 14.9842C9.41303 15.1049 11.1596 14.5393 12.5213 13.405L17.2413 18.125L18.125 17.2413ZM2.50001 8.12501C2.50001 7.01249 2.82991 5.92496 3.44799 4.99993C4.06608 4.0749 4.94458 3.35393 5.97242 2.92819C7.00025 2.50245 8.13125 2.39105 9.22239 2.60809C10.3135 2.82514 11.3158 3.36087 12.1025 4.14754C12.8892 4.93421 13.4249 5.93649 13.6419 7.02763C13.859 8.11877 13.7476 9.24977 13.3218 10.2776C12.8961 11.3054 12.1751 12.1839 11.2501 12.802C10.3251 13.4201 9.23753 13.75 8.12501 13.75C6.63368 13.7484 5.2039 13.1552 4.14936 12.1007C3.09483 11.0461 2.50167 9.61635 2.50001 8.12501Z"
      fill="#595959"
    />
  </svg>
);